// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const tvanetplayColors: ColorType = {
  ...colorPalette,
  primary: '#017ED2',
  secondary: '#017ED2',
  light: '#F8F4F4',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: tvanetplayColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: tvanetplayColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: tvanetplayColors.primaryGray,
    secondary: tvanetplayColors.secondaryGray,
    disabled: tvanetplayColors.grayText,
    link: tvanetplayColors.secondaryGray,
    hint: tvanetplayColors.white,
    highlight: tvanetplayColors.secondary,
    gray: tvanetplayColors.primaryGray,
    seeAll: tvanetplayColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: tvanetplayColors.primaryGray,
    gray: tvanetplayColors.secondaryGray,
  },
  filter: {
    primary: tvanetplayColors.primaryGray,
    secondary: tvanetplayColors.secondaryGray,
    disabled: tvanetplayColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: tvanetplayColors.dark,
    color: tvanetplayColors.white,
    border: tvanetplayColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: tvanetplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: tvanetplayColors.dark,
        selected: tvanetplayColors.dark,
        progress: rgba(tvanetplayColors.primary, 0.3),
        past: rgba(tvanetplayColors.primary, 0.3),
        pastSelected: tvanetplayColors.dark,
        pastHover: tvanetplayColors.dark,
        empty: '#555555',
        emptyProgress: rgba(tvanetplayColors.primary, 0.2),
      },
      text: {
        empty: tvanetplayColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: tvanetplayColors.white,
    subTitle: tvanetplayColors.secondaryGray,
    bg: tvanetplayColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    fullBGImage: true,
    fullBGImageSize: 'cover',
    signBGColor: '#252525',
    signLogoSize: 312,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
